import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizBaseCollector,
  WizCheckbox,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';

import { AlkEvent } from '../../../../framework/events/alk.event';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { ALK_EVENT_TYPE, WIDGET_KIND} from '../../../../model/enums';

/**
 * rendu des champs disponibles 
 */
@Component({
  selector: 'freedata-edit-item-renderer',
  templateUrl: './freedata-edit-item.renderer.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataEditItemRenderer implements IWizItemRenderer<null, PivotField> {
  @HostBinding('style.width') forcedWidth = '100%';
  
  @ViewChild('cbPinned', { read: WizCheckbox }) cbPinned: WizCheckbox;

  public data: PivotField;

  @Input()
  owner: WizBaseCollector;

  /** affichage de l'icone de conf du champ */
  get showSettings(): boolean {
    if (this.owner.id === 'lstRow' && this.useGridFunctions || this.owner.id === 'lstFilter') {
      return true;
    }
    return false; // la liste de choix contient des pkd, pas des pivotFields
  }

  /** autoriser la zone de drop de filtres et la col de sélection */
  public get useGridFunctions(): boolean {
    // console.log('fff', this.data);
    return this.data?.widget?.widgetKind === WIDGET_KIND.FD_GRID;
  }

  constructor(public elementRef: ElementRef) {}




  /** l'élément est actuellement utilisé */
  public isUsed(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id === 'freeList' && this.data.isUsed; // affichage de l'oeil uniquement dans la liste de choix
  }


  /** icone de suppression du champ de la zone de contenu, affichage uniquement dans les zones de drop */
  public isInContentList(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id !== 'freeList';
  }

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    this.owner.wizDataProvider.removeItem(this.data);
    WizEventManager.dispatchEvent(this.owner.elementRef, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.data));
  }

  /** ouverture de la sub-pop pour configurer la formule (et à terme, le style) */
  public showConf(): void {
    WizEventManager.dispatchEvent(
      this.owner.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, [this.data, this.owner])
    );
  }

  /** champ en ligne locked */
  public isPinned(): boolean {
    return !!this.data.pinned;
  }
  public setPinned(e: WizEvent) {
    this.data.pinned = e.value ? 'left' : null;
  }

  /** champ en ligne locked */
  public showPinned(): boolean {
    return this.useGridFunctions &&  this.owner.id === 'lstRow';
  }
}
